import Swal from 'sweetalert2';
import { playchat_conversation_downvote_Api } from '../../Apis/user/ApiConfig';
import {
    PLAYCHAT_CONVERSATION_DOWNVOTE_ERROR,
    PLAYCHAT_CONVERSATION_DOWNVOTE_REQUEST,
    PLAYCHAT_CONVERSATION_DOWNVOTE_SUCCESS,
} from '../../Types/user/Types';
import { message } from 'antd';

export const PlayChat_Conversation_downvote_Success = (res) => {
    return {
        type: PLAYCHAT_CONVERSATION_DOWNVOTE_SUCCESS,
        payload: res,
    };
};
export const PlayChat_Conversation_downvote_Error = (error) => {
    return {
        type: PLAYCHAT_CONVERSATION_DOWNVOTE_ERROR,
        error: error,
    };
};

export const PlayChat_Conversation_downvote_Request = (res) => {
    return {
        type: PLAYCHAT_CONVERSATION_DOWNVOTE_REQUEST,
        payload: res,
    };
};

export const PlayChat_Conversation_downvote_ActionHandler = (
    chatSession,
    messageId
) => {
    return (dispatch) => {
        dispatch(PlayChat_Conversation_downvote_Request());
        try {
            playchat_conversation_downvote_Api(chatSession, messageId)
                .then((res) => {
                    const errorMessage = res?.data?.message;
                    if (res) {
                        if (res && res.data && res.status === 200) {
                            message.success('Feedback sent successfully');
                            dispatch(
                                PlayChat_Conversation_downvote_Success(res.data)
                            );
                        } else {
                            dispatch(
                                PlayChat_Conversation_downvote_Error(
                                    errorMessage
                                )
                            );
                            Swal.fire({
                                timer: 0.1,
                                showConfirmButton: false,
                            });
                            message.error(
                                "Oops! Looks like you've already given feedback on this message"
                            );
                            return;
                        }
                    } else {
                        dispatch(
                            PlayChat_Conversation_downvote_Error(errorMessage)
                        );
                    }
                })
                .catch((err) => {
                    dispatch(
                        PlayChat_Conversation_downvote_Error(
                            'Something Went Wrong!!!'
                        )
                    );
                });
        } catch (err) {
            dispatch(PlayChat_Conversation_downvote_Error(err));
        }
    };
};
